// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════
   Test Plans · Release / Sprint / Epic — FULL-WIDTH workspace
   No permanent left rail. Searchable entity selector + plans table.
   ═══════════════════════════════════════════════════════════════════ */

.rt-plans-metrics {
  margin: 10px 0 2px;
}

.rt-plans-tabs {
  margin: 4px 0 8px;
  padding: 0 2px 2px;
  border-bottom: 1px solid var(--rt-border, #e2e8f0);
}

.rt-plans-tabs .rt-tabs {
  border-bottom: none;
  gap: 4px;
}

.rt-plans-tabs .rt-tabs__tab {
  padding: 10px 14px;
  border-radius: 8px 8px 0 0;
  font-weight: 600;
}

.rt-plans-tabs .rt-tabs__tab--active {
  background: rgba(37, 99, 235, 0.06);
}

/* Full-width entity workspace */
.rt-plans-fw {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 4px;
  min-width: 0;
}

/* ── Entity switcher ─────────────────────────────────────────────── */
.rt-plans-fw__switcher {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: var(--rt-surface, #fff);
  border: 1px solid var(--rt-border, #e2e8f0);
  border-radius: 12px;
}

.rt-plans-fw__switcher-left {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
  min-width: 0;
  flex: 1 1 320px;
}

.rt-plans-fw__switcher-label {
  display: block;
  width: 100%;
  margin: 0;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--rt-text-muted, #64748b);
}

.rt-plans-fw__entity-select {
  flex: 1 1 280px;
  min-width: 220px;
  max-width: 520px;
  width: min(100%, 520px);
}

/* Searchable entity combobox */
.rt-entity-ss {
  position: relative;
  min-width: 0;
}

.rt-entity-ss__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: 36px;
  padding: 0 10px 0 12px;
  border: 1px solid var(--rt-border, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--rt-text, #0f172a);
  cursor: pointer;
  text-align: left;
}

.rt-entity-ss__trigger:hover {
  border-color: #cbd5e1;
}

.rt-entity-ss.is-open .rt-entity-ss__trigger,
.rt-entity-ss__trigger:focus-visible {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.rt-entity-ss.is-disabled .rt-entity-ss__trigger {
  opacity: 0.55;
  cursor: not-allowed;
}

.rt-entity-ss__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-entity-ss__value.is-placeholder {
  color: var(--rt-text-muted, #64748b);
  font-weight: 500;
}

.rt-entity-ss__chevron {
  flex-shrink: 0;
  color: #64748b;
}

.rt-entity-ss__menu {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.14);
  overflow: hidden;
}

.rt-entity-ss__search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid #f1f5f9;
  color: #64748b;
  flex-shrink: 0;
}

.rt-entity-ss__search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.875rem;
  color: #0f172a;
}

.rt-entity-ss__clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.rt-entity-ss__clear:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.rt-entity-ss__list {
  list-style: none;
  margin: 0;
  padding: 4px;
  overflow: auto;
  flex: 1 1 auto;
}

.rt-entity-ss__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 7px;
  cursor: pointer;
  font-size: 0.8125rem;
}

.rt-entity-ss__option.is-active {
  background: #f1f5f9;
}

.rt-entity-ss__option.is-selected {
  background: rgba(37, 99, 235, 0.08);
}

.rt-entity-ss__option-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.rt-entity-ss__option-label {
  font-weight: 650;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-entity-ss__option-meta {
  font-size: 0.72rem;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-entity-ss__empty {
  padding: 16px 12px;
  text-align: center;
  font-size: 0.8125rem;
  color: #64748b;
}

.rt-entity-ss__hint {
  padding: 8px 10px 10px;
  text-align: center;
  font-size: 0.72rem;
  color: #94a3b8;
}

.rt-entity-ss__footer {
  flex-shrink: 0;
  padding: 8px 10px;
  border-top: 1px solid #f1f5f9;
  font-size: 0.72rem;
  color: #64748b;
  background: #f8fafc;
}

.rt-plans-fw__entity-count {
  font-size: 0.75rem;
  color: var(--rt-text-muted, #64748b);
  white-space: nowrap;
  padding-bottom: 8px;
}

.rt-plans-fw__switcher-loading,
.rt-plans-fw__switcher-empty {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  font-size: 0.875rem;
  color: var(--rt-text-muted, #64748b);
  min-height: 36px;
}

.rt-plans-fw__switcher-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

/* ── Selected entity header ──────────────────────────────────────── */
.rt-plans-fw__entity-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  border: 1px solid var(--rt-border, #e2e8f0);
  border-radius: 14px;
  position: relative;
  overflow: hidden;
}

.rt-plans-fw__entity-header::before {
  content: '';
  position: absolute;
  inset: 0 0 auto 0;
  height: 3px;
  background: linear-gradient(90deg, #2563eb, transparent 85%);
  pointer-events: none;
}

.rt-plans-fw__entity-header-main {
  min-width: 0;
  flex: 1 1 280px;
}

.rt-plans-fw__entity-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.rt-plans-fw__entity-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 750;
  letter-spacing: -0.025em;
  color: var(--rt-text, #0f172a);
  max-width: min(48ch, 100%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-plans-fw__entity-key {
  font-size: 0.75rem;
  font-weight: 650;
  padding: 2px 8px;
  border-radius: 6px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.rt-plans-fw__entity-meta {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  font-size: 0.8125rem;
  color: var(--rt-text-muted, #64748b);
}

.rt-plans-fw__entity-desc {
  max-width: 60ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-plans-fw__entity-header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

/* ── Metrics ─────────────────────────────────────────────────────── */
.rt-plans-fw__metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.rt-plans-fw__metrics .rt-metric-card {
  min-height: 100px;
}

.rt-plans-fw__entity-header,
.rt-plans-fw__switcher,
.rt-plans-fw__table {
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.rt-plans-fw__entity-header:hover,
.rt-plans-fw__switcher:hover,
.rt-plans-fw__table:hover {
  border-color: color-mix(in srgb, #2563eb 16%, #e2e8f0);
  box-shadow: 0 10px 24px -18px rgba(15, 23, 42, 0.25);
}

/* ── Plans toolbar + table ───────────────────────────────────────── */
.rt-plans-fw__toolbar {
  display: flex;
  align-items: center;
}

.rt-plans-fw__toolbar .rt-filter-bar {
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.rt-plans-fw__toolbar .rt-search {
  flex: 1 1 220px;
  max-width: 420px;
  height: 34px;
  border-radius: 8px;
}

.rt-plans-fw__toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.rt-plans-fw__table {
  background: var(--rt-surface, #fff);
  border: 1px solid var(--rt-border, #e2e8f0);
  border-radius: 12px;
  padding: 8px 10px 12px;
  min-width: 0;
  overflow: auto;
}

.rt-plans-fw__table thead th,
.rt-plans-fw__table .rt-table th {
  background: #f8fafc !important;
  color: #64748b !important;
  font-size: 0.6875rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 8px 10px !important;
  border-bottom: 1px solid var(--rt-border, #e2e8f0) !important;
  white-space: nowrap;
}

.rt-plans-fw__table tbody td,
.rt-plans-fw__table .rt-table td {
  padding: 8px 10px !important;
  font-size: 0.8125rem !important;
  vertical-align: middle !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.rt-plans-fw__table tbody tr:hover td {
  background: #f8fafc !important;
}

.rt-plans-fw__table .rt2-link {
  font-weight: 650;
  font-size: 0.8125rem;
}

.rt-plans-fw__table .rt2-muted {
  font-size: 0.72rem !important;
  color: #94a3b8 !important;
}

.rt-plans-fw__table .rt-pagination {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f1f5f9;
}

.rt-plans-fw__empty {
  padding: 48px 24px;
  background: var(--rt-surface, #fff);
  border: 1px dashed var(--rt-border, #e2e8f0);
  border-radius: 12px;
}

@media (max-width: 900px) {
  .rt-plans-fw__metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .rt-plans-fw__metrics {
    grid-template-columns: 1fr;
  }

  .rt-plans-fw__entity-select {
    max-width: none;
    width: 100%;
  }
}

/* Legacy class hooks (keep harmless if referenced) */
.rt-plans-entity {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-plans-entity.css"],"names":[],"mappings":"AAAA;;;wEAGwE;;AAExE;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0DAA0D;EAC1D,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,6EAA6E;AAC/E;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,4CAA4C;EAC5C,0DAA0D;AAC5D;;AAEA;;;EAGE,sDAAsD;EACtD,oDAAoD;AACtD;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,+BAA+B;EAC/B,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;AACf","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════\n   Test Plans · Release / Sprint / Epic — FULL-WIDTH workspace\n   No permanent left rail. Searchable entity selector + plans table.\n   ═══════════════════════════════════════════════════════════════════ */\n\n.rt-plans-metrics {\n  margin: 10px 0 2px;\n}\n\n.rt-plans-tabs {\n  margin: 4px 0 8px;\n  padding: 0 2px 2px;\n  border-bottom: 1px solid var(--rt-border, #e2e8f0);\n}\n\n.rt-plans-tabs .rt-tabs {\n  border-bottom: none;\n  gap: 4px;\n}\n\n.rt-plans-tabs .rt-tabs__tab {\n  padding: 10px 14px;\n  border-radius: 8px 8px 0 0;\n  font-weight: 600;\n}\n\n.rt-plans-tabs .rt-tabs__tab--active {\n  background: rgba(37, 99, 235, 0.06);\n}\n\n/* Full-width entity workspace */\n.rt-plans-fw {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 4px;\n  min-width: 0;\n}\n\n/* ── Entity switcher ─────────────────────────────────────────────── */\n.rt-plans-fw__switcher {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  background: var(--rt-surface, #fff);\n  border: 1px solid var(--rt-border, #e2e8f0);\n  border-radius: 12px;\n}\n\n.rt-plans-fw__switcher-left {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 10px;\n  min-width: 0;\n  flex: 1 1 320px;\n}\n\n.rt-plans-fw__switcher-label {\n  display: block;\n  width: 100%;\n  margin: 0;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--rt-text-muted, #64748b);\n}\n\n.rt-plans-fw__entity-select {\n  flex: 1 1 280px;\n  min-width: 220px;\n  max-width: 520px;\n  width: min(100%, 520px);\n}\n\n/* Searchable entity combobox */\n.rt-entity-ss {\n  position: relative;\n  min-width: 0;\n}\n\n.rt-entity-ss__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  height: 36px;\n  padding: 0 10px 0 12px;\n  border: 1px solid var(--rt-border, #e2e8f0);\n  border-radius: 8px;\n  background: #fff;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--rt-text, #0f172a);\n  cursor: pointer;\n  text-align: left;\n}\n\n.rt-entity-ss__trigger:hover {\n  border-color: #cbd5e1;\n}\n\n.rt-entity-ss.is-open .rt-entity-ss__trigger,\n.rt-entity-ss__trigger:focus-visible {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.rt-entity-ss.is-disabled .rt-entity-ss__trigger {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.rt-entity-ss__value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-entity-ss__value.is-placeholder {\n  color: var(--rt-text-muted, #64748b);\n  font-weight: 500;\n}\n\n.rt-entity-ss__chevron {\n  flex-shrink: 0;\n  color: #64748b;\n}\n\n.rt-entity-ss__menu {\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.14);\n  overflow: hidden;\n}\n\n.rt-entity-ss__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.rt-entity-ss__search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 0.875rem;\n  color: #0f172a;\n}\n\n.rt-entity-ss__clear {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.rt-entity-ss__clear:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.rt-entity-ss__list {\n  list-style: none;\n  margin: 0;\n  padding: 4px;\n  overflow: auto;\n  flex: 1 1 auto;\n}\n\n.rt-entity-ss__option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 7px;\n  cursor: pointer;\n  font-size: 0.8125rem;\n}\n\n.rt-entity-ss__option.is-active {\n  background: #f1f5f9;\n}\n\n.rt-entity-ss__option.is-selected {\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.rt-entity-ss__option-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.rt-entity-ss__option-label {\n  font-weight: 650;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-entity-ss__option-meta {\n  font-size: 0.72rem;\n  color: #64748b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-entity-ss__empty {\n  padding: 16px 12px;\n  text-align: center;\n  font-size: 0.8125rem;\n  color: #64748b;\n}\n\n.rt-entity-ss__hint {\n  padding: 8px 10px 10px;\n  text-align: center;\n  font-size: 0.72rem;\n  color: #94a3b8;\n}\n\n.rt-entity-ss__footer {\n  flex-shrink: 0;\n  padding: 8px 10px;\n  border-top: 1px solid #f1f5f9;\n  font-size: 0.72rem;\n  color: #64748b;\n  background: #f8fafc;\n}\n\n.rt-plans-fw__entity-count {\n  font-size: 0.75rem;\n  color: var(--rt-text-muted, #64748b);\n  white-space: nowrap;\n  padding-bottom: 8px;\n}\n\n.rt-plans-fw__switcher-loading,\n.rt-plans-fw__switcher-empty {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.875rem;\n  color: var(--rt-text-muted, #64748b);\n  min-height: 36px;\n}\n\n.rt-plans-fw__switcher-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n/* ── Selected entity header ──────────────────────────────────────── */\n.rt-plans-fw__entity-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 14px 16px;\n  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);\n  border: 1px solid var(--rt-border, #e2e8f0);\n  border-radius: 14px;\n  position: relative;\n  overflow: hidden;\n}\n\n.rt-plans-fw__entity-header::before {\n  content: '';\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 3px;\n  background: linear-gradient(90deg, #2563eb, transparent 85%);\n  pointer-events: none;\n}\n\n.rt-plans-fw__entity-header-main {\n  min-width: 0;\n  flex: 1 1 280px;\n}\n\n.rt-plans-fw__entity-title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.rt-plans-fw__entity-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 750;\n  letter-spacing: -0.025em;\n  color: var(--rt-text, #0f172a);\n  max-width: min(48ch, 100%);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-plans-fw__entity-key {\n  font-size: 0.75rem;\n  font-weight: 650;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  color: #475569;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n.rt-plans-fw__entity-meta {\n  margin-top: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  font-size: 0.8125rem;\n  color: var(--rt-text-muted, #64748b);\n}\n\n.rt-plans-fw__entity-desc {\n  max-width: 60ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-plans-fw__entity-header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n/* ── Metrics ─────────────────────────────────────────────────────── */\n.rt-plans-fw__metrics {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.rt-plans-fw__metrics .rt-metric-card {\n  min-height: 100px;\n}\n\n.rt-plans-fw__entity-header,\n.rt-plans-fw__switcher,\n.rt-plans-fw__table {\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.rt-plans-fw__entity-header:hover,\n.rt-plans-fw__switcher:hover,\n.rt-plans-fw__table:hover {\n  border-color: color-mix(in srgb, #2563eb 16%, #e2e8f0);\n  box-shadow: 0 10px 24px -18px rgba(15, 23, 42, 0.25);\n}\n\n/* ── Plans toolbar + table ───────────────────────────────────────── */\n.rt-plans-fw__toolbar {\n  display: flex;\n  align-items: center;\n}\n\n.rt-plans-fw__toolbar .rt-filter-bar {\n  width: 100%;\n  margin: 0;\n  padding: 8px 10px;\n  border-radius: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.rt-plans-fw__toolbar .rt-search {\n  flex: 1 1 220px;\n  max-width: 420px;\n  height: 34px;\n  border-radius: 8px;\n}\n\n.rt-plans-fw__toolbar-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.rt-plans-fw__table {\n  background: var(--rt-surface, #fff);\n  border: 1px solid var(--rt-border, #e2e8f0);\n  border-radius: 12px;\n  padding: 8px 10px 12px;\n  min-width: 0;\n  overflow: auto;\n}\n\n.rt-plans-fw__table thead th,\n.rt-plans-fw__table .rt-table th {\n  background: #f8fafc !important;\n  color: #64748b !important;\n  font-size: 0.6875rem !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  padding: 8px 10px !important;\n  border-bottom: 1px solid var(--rt-border, #e2e8f0) !important;\n  white-space: nowrap;\n}\n\n.rt-plans-fw__table tbody td,\n.rt-plans-fw__table .rt-table td {\n  padding: 8px 10px !important;\n  font-size: 0.8125rem !important;\n  vertical-align: middle !important;\n  border-bottom: 1px solid #f1f5f9 !important;\n}\n\n.rt-plans-fw__table tbody tr:hover td {\n  background: #f8fafc !important;\n}\n\n.rt-plans-fw__table .rt2-link {\n  font-weight: 650;\n  font-size: 0.8125rem;\n}\n\n.rt-plans-fw__table .rt2-muted {\n  font-size: 0.72rem !important;\n  color: #94a3b8 !important;\n}\n\n.rt-plans-fw__table .rt-pagination {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.rt-plans-fw__empty {\n  padding: 48px 24px;\n  background: var(--rt-surface, #fff);\n  border: 1px dashed var(--rt-border, #e2e8f0);\n  border-radius: 12px;\n}\n\n@media (max-width: 900px) {\n  .rt-plans-fw__metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .rt-plans-fw__metrics {\n    grid-template-columns: 1fr;\n  }\n\n  .rt-plans-fw__entity-select {\n    max-width: none;\n    width: 100%;\n  }\n}\n\n/* Legacy class hooks (keep harmless if referenced) */\n.rt-plans-entity {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
